import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { RmaFee, rmaFeeSchema } from '@sophocles/entities/RmaFee/rmaFeeRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_RMA_FEES = 'RECEIVE_RMA_FEES';
function receiveRmaFees(json) {
  return {
    type: RECEIVE_RMA_FEES,
    rmaFees: mapListToRecords(json, RmaFee),
  };
}

/* Request Actions */
// starter request
export const REQUEST_RMA_FEE = 'REQUEST_RMA_FEE';
function requestRmaFee(rmaFee_id) {
  return {
    type: REQUEST_RMA_FEE,
    rmaFee_id,
  };
}

export const REQUEST_ALL_RMA_FEES = 'REQUEST_ALL_RMA_FEES';
function requestAllRmaFees() {
  return {
    type: REQUEST_ALL_RMA_FEES,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchRmaFee(rmaFee_id) {
  return dispatch => {
    dispatch(requestRmaFee(rmaFee_id));
    return apiClient
      .get(`/rmafees/${rmaFee_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'rmaFees', rmaFeeSchema))
      .then(json => dispatch(receiveRmaFees(json.entities.rmaFees)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RMA_FEE)));
  };
}

export function fetchAllRmaFees() {
  return dispatch => {
    dispatch(requestAllRmaFees());
    return apiClient
      .get(`/rmafees/?limit=1000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'rmaFees', rmaFeeSchema))
      .then(json => dispatch(receiveRmaFees(json.entities.rmaFees)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RMA_FEE)));
  };
}

// Used in RMA Fee call
export function rawFetchAllRMAFees() {
  return dispatch => {
    dispatch(requestAllRmaFees());
    return apiClient
      .get(`/rmafees/?limit=1000`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RMA_FEE)));
  };
}

/* Edit Actions */
export const EDIT_RMA_FEE = 'EDIT_RMA_FEE';
export function editRmaFee(rmaFee_id) {
  return {
    type: EDIT_RMA_FEE,
    rmaFee: rmaFee_id,
  };
}

export function patchRmaFee(rmaFee_id, values) {
  return dispatch => {
    dispatch(editRmaFee(rmaFee_id));
    return apiClient
      .patch(`/rmafees/${rmaFee_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, rmaFeeSchema))
      .then(json => dispatch(receiveRmaFees(json.entities.rmaFees)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_RMA_FEE)));
  };
}

/* Create Actions */
export const CREATE_RMA_FEE = 'CREATE_RMA_FEE';
function sayCreateRmaFee(values) {
  return {
    type: CREATE_RMA_FEE,
    values: values,
  };
}

export function createRmaFee(values) {
  return dispatch => {
    dispatch(sayCreateRmaFee(values));
    return apiClient
      .post(`/rmafees/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, rmaFeeSchema))
      .then(json => dispatch(receiveRmaFees(json.entities.rmaFees)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_RMA_FEE)));
  };
}

/* Delete Actions */
export const DELETE_RMA_FEE = 'DELETE_RMA_FEE';
function sayDeleteRmaFee(rmaFee_id) {
  return {
    type: DELETE_RMA_FEE,
    rmaFee: rmaFee_id,
  };
}

export function deleteRmaFee(rmaFee_id) {
  return dispatch =>
    apiClient
      .delete(`/rmafees/${rmaFee_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteRmaFee(rmaFee_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_RMA_FEE)));
}
